import React, { useEffect, useState } from "react";
import { useSnackbar } from "react-simple-snackbar";
import { useParams } from "react-router-dom";
import GTabs from "../gComponents/gTabs";
import { TableContainer, Link } from "@material-ui/core";
import {
  Table,
  TableBody,
  TableRow,
  TableRowData,
  TableHead,
  TableHeader,
} from "./../styledComponents/tableStyle";
import { ApiService } from "../services";
import { Add, Edit, Delete } from "@material-ui/icons";
import GButton from "../gComponents/gButton";
import GEmpty from "../gComponents/gEmpty";
import GConfirmDialog from "../gComponents/gConfirmDialog";
import GTableShimmer from "../gComponents/gTableShimmer";
import SurgeTimeslotsForm from "../forms/surgeTimeslotsForm";
import Modal from "react-modal";
import GSwitch from "../gComponents/gSwitch";

const columns = [
  { id: "from_time", label: "From Time", minWidth: 100 },
  { id: "to_time", label: "To Time", minWidth: 150, align: "center" },
  { id: "percentage", label: "Percentage", minWidth: 100, align: "center" },
  { id: "actions", label: "Actions", minWidth: 60, align: "center" },
];

const timeRoutes = [
  {
    title: "mon",
    link: "/settings/surge-timeslots/mon",
    state: "setting",
  },
  {
    title: "tue",
    link: "/settings/surge-timeslots/tue",
    state: "setting",
  },
  {
    title: "wed",
    link: "/settings/surge-timeslots/wed",
    state: "setting",
  },
  {
    title: "thu",
    link: "/settings/surge-timeslots/thu",
    state: "setting",
  },
  {
    title: "fri",
    link: "/settings/surge-timeslots/fri",
    state: "setting",
  },
  {
    title: "sat",
    link: "/settings/surge-timeslots/sat",
    state: "setting",
  },
  {
    title: "sun",
    link: "/settings/surge-timeslots/sun",
    state: "setting",
  },
];

export default function SurgeTimeslots({ match }) {
  const [openSnackbar] = useSnackbar();
  const [typeValue, setTypeValue] = React.useState("mon");
  const [timeslotData, setTimeslotData] = React.useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedTimeslotId, setSelectedTimeslotId] = useState("");
  const [sTsvisible, setSTsvisible] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState({});
  const [isEmpty, setIsEmpty] = React.useState(true);
  const [isLoading, setIsLoading] = useState(true);
  let { weekday } = useParams();

  function getTimeslots() {
    ApiService({ method: "GET", route: "surge-timeslots" })
      .then((response) => {
        console.log(response);
        if (response.data.status_code === 1) {
          setTimeslotData(response.data.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  useEffect(() => {
    console.log(typeValue);
    getTimeslots();
    setTypeValue(weekday ? weekday : "mon");
  }, [weekday]);

  const deleteTimeslot = () => {
    ApiService({
      method: "DELETE",
      route: "surge-timeslots/" + selectedTimeslotId,
    })
      .then((response) => {
        console.log(response);
        if (response.data.status_code === 1) {
          getTimeslots();
        }
        openSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="rightInnerView">
      <h2>
        Surge Timeslots{" "}
        <GButton
          variant="condensed"
          children="Add"
          onClick={() => {
            setIsEmpty(true);
            setSelectedSlot({});
            setSTsvisible(true);
          }}
          style={{
            float: "right",
          }}
        >
          Add
        </GButton>
      </h2>

      <GTabs routes={timeRoutes} active={typeValue}></GTabs>

      <div className="listPaper">
        <div>
          {isLoading === true ? (
            <GTableShimmer></GTableShimmer>
          ) : timeslotData.filter((t) => t.weekday === typeValue).length ===
            0 ? (
            <GEmpty></GEmpty>
          ) : (
            <TableContainer>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableHeader
                        key={column.id}
                        style={{
                          minWidth: column.minWidth,
                          textAlign: column.align,
                        }}
                      >
                        {column.label}
                      </TableHeader>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {timeslotData
                    .filter((t) => t.weekday === typeValue)
                    .map((c) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={c.id}
                        >
                          <TableRowData>{c.from_time}</TableRowData>
                          <TableRowData
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {c.to_time}
                          </TableRowData>
                          <TableRowData
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {c.percentage}
                          </TableRowData>
                          <TableRowData
                            style={{
                              textAlign: "center",
                            }}
                          >
                            <GButton
                              variant="linkable"
                              onClick={(e) => {
                                setSelectedSlot(c);
                                setIsEmpty(false);
                                setSTsvisible(true);
                              }}
                            >
                              <Edit fontSize="small" />
                            </GButton>

                            <GButton
                              variant="linkable"
                              onClick={(e) => {
                                setSelectedTimeslotId(c.id);
                                setDialogOpen(true);
                              }}
                            >
                              <Delete fontSize="small" />
                            </GButton>
                          </TableRowData>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
      {dialogOpen === true ? (
        <GConfirmDialog
          open={dialogOpen}
          title="Delete Surge Timeslot"
          text="Are you sure you want to delete this surge timeslot?"
          handleClose={() => setDialogOpen(false)}
          onConfirmClose={() => {
            setDialogOpen(false);
            deleteTimeslot();
          }}
        ></GConfirmDialog>
      ) : (
        ""
      )}

      <Modal
        isOpen={sTsvisible}
        className="modal modalRight"
        overlayClassName="modal-overlay"
        onRequestClose={() => setSTsvisible(false)}
        style={{
          content: {
            width: "400px",
          },
        }}
        contentLabel="Timeslot Form Modal"
      >
        <SurgeTimeslotsForm
          sTsvisible={sTsvisible}
          setSTsvisible={setSTsvisible}
          isEmpty={isEmpty}
          data={selectedSlot}
          weekday={typeValue}
          onSubmit={getTimeslots}
        />
      </Modal>
    </div>
  );
}
